import {useRechnerStore} from '../stores/rechner';
import {isValidDateInPast, isValidDateInPast18, isValidVersicherungsbeginnAR20} from '../helpers/hilfsfunktionen';
import moment from 'moment';

export function validatorTrimNotEmpty() {
    return {
        validate: function (input) {
            const value = input.value;
            if (value.trim().length > 0) {
                return {
                    valid: true,
                };
            }

            return {
                valid: false,
            };

        },
    };
}

export function validatorAnrede() {
    return {
        validate: function (input) {
            const value = input.value;
            if (value === "Herr" || value === "Frau") {
                return {
                    valid: true,
                };
            }

            return {
                valid: false,
            };

        },
    };
}

export function validatorIstInList() {
    return {
        validate: function (input) {
            const value = input.value;
            const items = input.options.list;
            return {
                valid: items.includes(value),
            };
        },
    };
}


export function validatorHono() {
    return {
        validate: function (input) {

            const value = input.value;
            let Ergebnis = isValidDateInPast(value);

            return {
                valid: Ergebnis,
            };


        },
    };
}

export function validatorGebHono() {
    return {
        validate: function (input) {

            const value = input.value;
            let Ergebnis = isValidDateInPast18(value);

            return {
                valid: Ergebnis,
            };


        },
    };
}

export function validatorKontoinhaberAbweichend() {
    return {
        validate: function (input) {
            const value = input.value;
            

            if (value === "true" || value === "false" || value === false || value === true) {
            
                return {
                    valid: true,
                };
            }
           
           
            return {
                valid: false,
            };

        },
    };
}


export function validatorAbweichendeKundenentscheidungText() {
    return {
        validate: function (input) {
            const store = useRechnerStore();
            const value = input.value;
            const length = value.length;
            if (store.kundenentscheid === 1) {
                if (length > 0) {
                    return {
                        valid: true,
                    };
                }
            } else {
                if (length === 0) {
                    return {
                        valid: true,
                    };
                }
            }

            return {
                valid: false,
            };

        },
    };
}

function isValid(value) {
    // Assuming `setValue`, `error`, `IS_EMPTY`, `WRONG_FORMAT`, and `WRONG_NUMBER` are implemented elsewhere


    if (!value) {

        return false;
    }

    const pattern = /^[a-zA-Z]{1}[0-9]{9}$/;
    let checkmodus = 0;

    if (pattern.test(value)) {
        checkmodus = 2;
    }

    if (checkmodus === 0) {
        return false;
    }

    const arrKVNR = value.split('');
    const charCount = String(ord(arrKVNR[0].toUpperCase()) - 64).padStart(2, '0').split('');
    arrKVNR.shift();

    arrKVNR.unshift(charCount[0], charCount[1]);

    let digitSum = 0;
    for (let i = 0; i < arrKVNR.length - 1; i++) {
        if (i % 2 > 0) {
            digitSum += sumDigits(arrKVNR[i] * 2);
        } else {
            digitSum += sumDigits(arrKVNR[i]);
        }
    }

    return digitSum % 10 === parseInt(arrKVNR[10]);


}

function ord(string) {
    return string.charCodeAt(0);
}

function sumDigits(number) {
    return String(number).split('').reduce((sum, digit) => sum + parseInt(digit), 0);
}

export function validatorKVNummer() {
    return {
      validate: function (input) {
        
          const value = input.value;          
          if (isValid(value)===true) {          
            return {
              valid: true,
            };
          }
          
          return {
            valid: false,
          };
  
      },
  };
  }

  export function validatorKVNummerSpecial() {
    return {
      validate: function (input) {
          
          const value = input.value;  
          if (value==="AOK") {
            return {
              valid: true,
            };
          }
          if (isValid(value)) {          
            return {
              valid: true,
            };
          }
          
          return {
            valid: false,
          };
  
      },
  };
  }

  export function validatorKVNummerDoppelt() {
    return {
      validate: function (input) {
          
          const value = input.value;  
          const store = useRechnerStore();
  
          if (store.KVNrDoppelt(value) === true) {
            return {
              valid: false,
            };  
          }
  
          
          return {
            valid: true,
          };
  
      },
  };
  }

  /**
   * Validator für AR20 Versicherungsbeginn
   * Gültig: heute bis max 6 Monate in die Zukunft
   */
  export function validatorVersicherungsbeginnAR20() {
    return {
      validate: function (input) {
        const value = input.value;
        
        // Leeres Feld ist ungültig
        if (!value || value.trim() === '') {
          return { valid: false };
        }
        
        // Prüfe ob Datum im gültigen Bereich liegt
        const isValid = isValidVersicherungsbeginnAR20(value);
        return { valid: isValid };
      },
    };
  }

  /**
   * Validator für AR20 Geburtsdatum
   * Gültig: Datum in der Vergangenheit, max 105 Jahre alt
   */
  export function validatorGeburtsdatumAR20() {
    return {
      validate: function (input) {
        const value = input.value;
        
        // Leeres Feld ist ungültig
        if (!value || value.trim() === '') {
          return { valid: false };
        }
        
        // Prüfe ob Datum in der Vergangenheit liegt und max 105 Jahre alt
        const isValid = isValidDateInPast(value);
        return { valid: isValid };
      },
    };
  }

  /**
   * Validator für ARNF: Geburtsdatum der ältesten Person
   * Prüft, dass das Geburtsdatum der ältesten Person nicht NACH dem Geburtsdatum des VN liegt
   * (Die älteste Person muss älter oder gleich alt sein wie der VN)
   */
  export function validatorAeltestePerson() {
    return {
      validate: function (input) {
        const store = useRechnerStore();
        const geburtsdatumAelteste = input.value;
        
        // Leeres Feld ist ungültig
        if (!geburtsdatumAelteste || geburtsdatumAelteste.trim() === '') {
          return { valid: false };
        }
        
        // Geburtsdatum des VN (erste Person bei ARNF)
        const vnItem = store.items[0];
        if (!vnItem || !vnItem.geburtstag) {
          // VN-Geburtsdatum noch nicht eingegeben - Validierung bestanden
          return { valid: true };
        }
        
        const gebAelteste = moment(geburtsdatumAelteste, 'YYYY-MM-DD', true);
        const gebVN = moment(vnItem.geburtstag, 'YYYY-MM-DD', true);
        
        if (!gebAelteste.isValid() || !gebVN.isValid()) {
          return { valid: true }; // Andere Validatoren prüfen das Format
        }
        
        // Die älteste Person darf nicht jünger sein als der VN
        // Also: gebAelteste <= gebVN (ältere Person hat früheres Geburtsdatum)
        if (gebAelteste.isAfter(gebVN)) {
          return { valid: false };
        }
        
        return { valid: true };
      },
    };
  }